import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Hero from '../components/Hero';
import About from '../components/About';
import Zakool from '../components/Zakool';
import Publications from '../components/Publications';
import Journey from '../components/Journey';
import Vision from '../components/Vision';
import Contact from '../components/Contact';
import SEO from '../components/SEO';

const Home = () => {
  useEffect(() => {
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        setTimeout(() => element.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <SEO
        title="Co-Founder & CEO, Zakool AI"
        description="Anu Singh is the Co-Founder and CEO of Zakool AI, building AI sales infrastructure for real estate developers and brokerages across the UAE and India."
        path="/"
      />

      <Hero />

      <section id="about" className="scroll-mt-20">
        <About />
      </section>

      <section id="zakool" className="scroll-mt-20">
        <Zakool />
      </section>

      <section id="perspectives" className="scroll-mt-20">
        <Publications />
      </section>

      <section id="journey" className="scroll-mt-20">
        <Journey />
      </section>

      <section id="point-of-view" className="scroll-mt-20">
        <Vision />
      </section>

      <section id="contact" className="scroll-mt-20">
        <Contact />
      </section>
    </motion.div>
  );
};

export default Home;
